// NOTE: Remove all non-digits, minus if it's not at the start and 0 if it's at the start
export const formatStringValue = (value: string, isDecimalAllowed = false) => {
  let result = value.replace(/-/g, '') // Remove all minus signs
  if (!isDecimalAllowed) {
    result = result
      .replace(/[^0-9]/g, '') // Remove non-digits
      .replace(/^0+(?=\d)/g, '') // Remove leading zeros
  } else {
    result = result
      .replace(/[^-0-9,.]/g, '') // Remove non-digits and non-dots
      .replace(/,/g, '.') // Replace commas with dots
      .replace(/\.+(?=\.)/g, '') // Replace groups of dots with a single dot
    const [intPart, decimalPart] = result.split('.')
    if (decimalPart !== undefined) {
      result = `${intPart}.${decimalPart.slice(0, 1)}`
    }
    result = result.replace(/^0+(?=(0|\d))/g, '') // Remove leading zeros
  }
  result = result.replace(/^/, value.startsWith('-') ? '-' : '') // Restore minus at start if original had it
  return result
}

export const isEmptyOrMinus = (value: string) => ['', '-'].includes(value)

export const clampValueToMinMaxRange = (
  value: number,
  min: number,
  max: number,
) => {
  if (value < min) {
    return min
  }
  if (value > max) {
    return max
  }
  return value
}

export const convertNumberValueToStringValue = (
  numberValue: number | null | undefined,
) => {
  if (typeof numberValue !== 'number' || Number.isNaN(numberValue)) {
    return ''
  }
  return numberValue.toString()
}
